/* eslint-disable camelcase */
import { ERROR_LOG } from './config';

export default class Merkmal {
  static is_Wert(m) { return m.typ === 'Wert'; }

  static is_Zeit_related(m) { return m.typ.startsWith('zeit'); } // zeitlich (=zeitklassifizierend) OR zeitidentifizierend

  static is_Raum_related(m) { return m.typ.startsWith('räumlich'); }

  static has_auspraegungen(m) { return !['Wert', 'zeitidentifizierend'].includes(m.typ); }

  static has_zeitscheiben(m) { return m.typ === 'zeitidentifizierend'; }

  static has_unit(m) { return m.typ === 'Wert'; }

  /** Sort function for table titles:
   *  1. Werte
   *  2. Räume
   *  3. Zeiten
   *  4. all other
   * @param {Merkmal} ma a
   * @param {merkmal} mb b
   * @return {int} -1 if a < b, 0 if a == b, 1 if a > b
   */
  static title_cmp(ma, mb) {
    if (ma.typ === mb.typ) { return 0; } // eslint- equal types have equal priority (stable sort)
    if (ma.typ === 'Wert') { return -1; }
    if (mb.typ === 'Wert') { return 1; }
    if (ma.typ.startsWith('räum')) { return -1; }
    if (mb.typ.startsWith('räum')) { return 1; }
    if (ma.typ.startsWith('zeit')) { return -1; }
    if (mb.typ.startsWith('zeit')) { return 1; }
    return 0; // eslint- everything else keeps their order
  }

  static get_short_label(merkmal) {
    const mclass = {
      klassifizierend: { short: 'kl.' },
      insgesamt: { short: 'in.' },
      räumlich: { short: 'rk.' },
      'räumlich insgesamt': { short: 'ri.' },
      sachlich: { short: 'sk.' },
      wert: { short: 'we.' },
      zeitlich: { short: 'zk.' },
      zeitidentifizierend: { short: 'zi.' },
      alle: { short: 'al.' },
    };
    const merkmal_typ = merkmal.typ && merkmal.typ.toLowerCase();
    const val = mclass[merkmal_typ];
    if (!val) {
      // eslint-disable-next-line no-console
      if (ERROR_LOG) { console.warn(`getMerkmalTyp_short_label found unknown typ '${merkmal.typ}'`); }
      return '??';
    }
    return val.short;
  }
}
